export default "/app/themes/majeures/build/images/avatar4.svg?7bdeb7451ba42c666a4f460ad7b49ba5";